import { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isImpersonating, setIsImpersonating] = useState(!!localStorage.getItem('sp_token_admin'));

  useEffect(() => {
    const token = localStorage.getItem('sp_token');
    if (!token) { setLoading(false); return; }
    api.me().then(setUser).catch(() => { localStorage.removeItem('sp_token'); }).finally(() => setLoading(false));
  }, []);

  const login = async (email, haslo) => {
    const data = await api.login(email, haslo);
    localStorage.setItem('sp_token', data.token);
    // Pobierz pełny profil (zawiera is_admin, email_verified itp.)
    const fullUser = await api.me();
    setUser(fullUser);
    return data;
  };

  const register = async (email, haslo, imie) => {
    const data = await api.register(email, haslo, imie);
    localStorage.setItem('sp_token', data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    api.logout();
    localStorage.removeItem('sp_token_admin');
    setIsImpersonating(false);
    setUser(null);
    const lang = localStorage.getItem('sp_lang') || 'pl';
    window.location.href = lang === 'en' ? 'https://scanpilots.com/' : 'https://scanpilots.com/pl/';
  };

  const impersonate = async (userId) => {
    const data = await api.adminImpersonate(userId);
    localStorage.setItem('sp_token_admin', localStorage.getItem('sp_token'));
    localStorage.setItem('sp_token', data.token);
    const fullUser = await api.me();
    setUser(fullUser);
    setIsImpersonating(true);
  };

  const stopImpersonating = async () => {
    const adminToken = localStorage.getItem('sp_token_admin');
    if (!adminToken) return;
    localStorage.setItem('sp_token', adminToken);
    localStorage.removeItem('sp_token_admin');
    const fullUser = await api.me();
    setUser(fullUser);
    setIsImpersonating(false);
  };

  // Powitalny modal — wywoływany z WelcomeModal po kliknięciu "Zaczynamy".
  // Marks server-side + lokalnie aktualizuje user.welcome_seen, modal znika natychmiast.
  const dismissWelcome = async () => {
    try { await api.welcomeDismiss(); } catch (e) { /* ignore — i tak ukryjemy lokalnie */ }
    setUser(u => u ? { ...u, welcome_seen: true } : u);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, impersonate, stopImpersonating, isImpersonating, dismissWelcome }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
